const getters = {
    x_auth_token: state => state.login.x_auth_token,
    x_auth_agent: state => state.agent.x_auth_agent,
    avatar: state => state.user.avatar,
    name: state => state.user.name,
    introduction: state => state.user.introduction,
    rolesMember: state => state.login.roles,
    permission_routes: state => state.permission.routes,
    errorLogs: state => state.errorLog.logs,
    roomListArr: state => state.omniroom.roomListArr,
    hotChatListArr: state => state.omniroom.hotChatListArr,
    activeRoomId: state => state.omniroom.activeRoomId,
    activeProvider: state => state.omniroom.activeProvider,
    messageListArr: state => state.omniroom.messageListArr,
    textMessageArr: state => state.omniroom.textMessageArr,
    // agentSession: state => state.agent.agentSession,
    agentSession: state => state.agent.agentSession,
    NEW_UNREAD_MESSAGE_ROOM_Data: state => state.pusher.NEW_UNREAD_MESSAGE_ROOM_Data,
    NEW_NUM_UNREAD_MESSAGE_ROOM_Data: state => state.pusher.NEW_NUM_UNREAD_MESSAGE_ROOM_Data,
    fieldsGetLicenseList: state => state.license.fieldsGetLicenseList,
    fieldsGetAgentList: state => state.agent.fieldsGetAgentList,
    getHotChatListArrById: (state) => (id) => {
        return state.omniroom.hotChatListArr.find(msgs => msgs.id === id)
    },
    getHotChatListArrByDate: (state) => (date) => {
        return state.omniroom.hotChatListArr.find(msgs => msgs.timeISODate === date)
    },
    getKlineDataById: (state) => (id) => {
        return state.binance.klineData.find(msgs => msgs.id === id)
    },
    getMarketBySymbol: (state) => (id) => {
        return state.binance.coinList.find(msgs => msgs.id === id)
    },
    getBalanceDataByAsset: (state) => (asset) => {
        return state.binance.balancesData.find(msgs => msgs.asset === asset)
    },
    getRoomById: (state) => (id) => {
        return state.omniroom.roomListArr.find(room => room.id === id)
    },
    SCAN_QRCODE_Data: state => state.pusher.SCAN_QRCODE_Data,
    logoutCounter: state => state.omniwa.logoutCounter,
    getProductMonthlyListArrById: (state) => (id) => {
        return state.product.monthlyListArr.find(msgs => msgs.id === id)
    },
    getProductAnnuallyListArrById: (state) => (id) => {
        return state.product.annuallyListArr.find(msgs => msgs.id === id)
    },
    getProductSixMonthListArrById: (state) => (id) => {
        return state.product.sixMonthListArr.find(msgs => msgs.id === id)
    },
    getProductFreeListArrById: (state) => (id) => {
        return state.product.freeListArr.find(msgs => msgs.id === id)
    },
    getProductSmaartListArrById: (state) => (id) => {
        return state.product.smartListArr.find(msgs => msgs.id === id)
    },
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js